// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2yJjH","fileDisabled":"File_fileDisabled__3lXST"};